// Vue
import { onMounted, onUnmounted, ref, watch } from 'vue';

// Controller
import MonitoramentoTempoUsoController from './MonitoramentoTempoUsoController';

// Router
import { useRoute } from 'vue-router';
import { obterNameRota } from '@/router/NavegacaoUtils';

// Services
import CSessao from '@/services/storage/CSessao';
import CMonitoramentoTempoUso from '../monitoramento-tempo-uso/CMonitoramentoTempoUso';

export function useTempoTelaComposable() {
  const sessionId = ref(crypto.randomUUID());
  let pingInterval: ReturnType<typeof setInterval> | null = null;
  const cINTERVALO_REGISTRO_TEMPO_USO = 30000;

  const route = useRoute();
  const dataHoraInicioDaRota = ref(new Date().toISOString());

  const payload = () => {
    const agora = new Date().toISOString();

    return new CMonitoramentoTempoUso({
      sessaoId: sessionId.value,
      path: window.location.pathname,
      identificador: String(obterNameRota()),
      dataHoraInicio: dataHoraInicioDaRota.value,
      dataHoraTermino: agora,
    });
  };

  const sendPing = async () => {
    try {
      if (!CSessao.sessaoAtual.token) return;
      await new MonitoramentoTempoUsoController().registrar(payload());
    } catch (error) {
      console.error('Erro ao enviar ping de tempo de tela', error);
    }
  };

  const startPinging = () => {
    if (!pingInterval) {
      sendPing(); // Ping inicial do novo ciclo
      pingInterval = setInterval(sendPing, cINTERVALO_REGISTRO_TEMPO_USO);
    }
  };

  const stopPinging = () => {
    if (pingInterval) {
      clearInterval(pingInterval);
      pingInterval = null;
    }
  };

  // Vigia as trocas de Tela
  watch(
    () => route.path,
    () => {
      if (document.visibilityState === 'visible') {
        sendPing();
        dataHoraInicioDaRota.value = new Date().toISOString();
      }
    },
  );

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      // O usuário voltou para a aplicação. Inicia um novo bloco de contagem.
      dataHoraInicioDaRota.value = new Date().toISOString();
      startPinging();
    } else {
      // O usuário saiu da aplicação. Envia o período acumulado e encerra o bloco.
      sendPing();
      stopPinging();
    }
  };

  const handleBeforeUnload = () => {
    if (!CSessao.sessaoAtual.token) return;
    stopPinging();

    //  O sendBeacon exige que o objeto seja convertido em string (JSON) ou Blob
    const dadosFormatados = JSON.stringify(payload());
    const endpoint = new MonitoramentoTempoUsoController().endpoints.registrar;

    // Como estamos mandando JSON, é recomendado usar Blob com o Content-Type
    const blob = new Blob([dadosFormatados], { type: 'application/json' });
    navigator.sendBeacon(endpoint, blob);
  };

  onMounted(() => {
    if (document.visibilityState === 'visible') {
      startPinging();
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);
  });

  onUnmounted(() => {
    stopPinging();
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });

  return { sessionId };
}
